export default {
    company: null,
    socials: [],
    facebookPixel: null,
    googleAds: null,
    companySettings: null
}
  